module.exports = __webpack_public_path__ + "img/home-logo.a7be8ffb.png";